import './portal-rubrics-switcher.scss';
